import a from "react";
var l = Object.defineProperty,
  o = Object.getOwnPropertySymbols,
  i = Object.prototype.hasOwnProperty,
  p = Object.prototype.propertyIsEnumerable,
  n = (t, e, r) => e in t ? l(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[e] = r,
  c = (t, e) => {
    for (var r in e || (e = {})) i.call(e, r) && n(t, r, e[r]);
    if (o) for (var r of o(e)) p.call(e, r) && n(t, r, e[r]);
    return t;
  };
const v = t => a.createElement("svg", c({
  width: "11",
  height: "8",
  viewBox: "0 0 11 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t), a.createElement("path", {
  d: "M7.20656 6.20744C6.4267 7.48358 4.5733 7.48357 3.79344 6.20744L0 0L11 0L7.20656 6.20744Z",
  fill: "var(--color-neutral-80)"
}), a.createElement("path", {
  d: "M6.49562 7.3708C6.04695 8.10499 4.95305 8.10499 4.50438 7.3708L0 0L11 0L6.49562 7.3708Z",
  fill: "var(--color-neutral-80)"
}));
export { v as PinIcon };